// 预采类型
export const PLAN_TYPE = {
    // 今日预采
    T0: 0,
    // 明日预采
    T1: 1,
};

export default {};
